import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UsersIcon, SearchIcon, BuildingIcon } from 'lucide-react';
const Solutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="flex-grow bg-gray-50" data-id="element-460">
      {/* Hero Section */}
      <div className="bg-primary pt-20 pb-24 text-center px-4 sm:px-6 lg:px-8" data-id="element-461">
        <div className="max-w-3xl mx-auto" data-id="element-462">
          <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl" data-id="element-463">
            Solutions for Every Team
          </h1>
          <p className="mt-6 text-xl text-textlight" data-id="element-464">
            Whether you're an in-house marketer, an SEO specialist, or an
            agency, Steward gives you the tools to win in AI search.
          </p>
        </div>
      </div>

      {/* Solutions Grid */}
      <div className="max-w-7xl mx-auto py-20 px-4 sm:px-6 lg:px-8" data-id="element-465">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-466">
          {/* Solution 1 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-467">
            <div className="w-14 h-14 rounded-xl bg-accent/10 flex items-center justify-center mb-6" data-id="element-468">
              <UsersIcon className="w-7 h-7 text-accent" data-id="element-469" />
            </div>
            <h3 className="text-2xl font-bold text-customblack mb-4" data-id="element-470">
              For Marketing Teams
            </h3>
            <p className="text-customgray leading-relaxed flex-grow" data-id="element-471">
              Ensure your brand is visible and accurately represented across
              AI-powered search experiences. Track brand mentions, optimize your
              core content, and measure the impact of your AEO strategy on
              overall brand awareness.
            </p>
            <ul className="mt-6 space-y-3 border-t border-gray-100 pt-6" data-id="element-472">
              <li className="flex items-center text-sm text-customgray" data-id="element-473">
                <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2" data-id="element-474"></span>{' '}
                Brand reputation monitoring
              </li>
              <li className="flex items-center text-sm text-customgray" data-id="element-475">
                <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2" data-id="element-476"></span>{' '}
                Share of voice tracking
              </li>
              <li className="flex items-center text-sm text-customgray" data-id="element-477">
                <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2" data-id="element-478"></span>{' '}
                Executive reporting dashboards
              </li>
            </ul>
          </div>

          {/* Solution 2 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-479">
            <div className="w-14 h-14 rounded-xl bg-accentwarm/10 flex items-center justify-center mb-6" data-id="element-480">
              <SearchIcon className="w-7 h-7 text-accentwarm" data-id="element-481" />
            </div>
            <h3 className="text-2xl font-bold text-customblack mb-4" data-id="element-482">
              For SEO Professionals
            </h3>
            <p className="text-customgray leading-relaxed flex-grow" data-id="element-483">
              Expand your optimization strategy beyond traditional search.
              Monitor AI engine rankings, identify new keyword opportunities
              triggered by conversational queries, and stay ahead of rapid
              algorithm changes.
            </p>
            <ul className="mt-6 space-y-3 border-t border-gray-100 pt-6" data-id="element-484">
              <li className="flex items-center text-sm text-customgray" data-id="element-485">
                <span className="w-1.5 h-1.5 rounded-full bg-accentwarm mr-2" data-id="element-486"></span>{' '}
                Schema markup validation
              </li>
              <li className="flex items-center text-sm text-customgray" data-id="element-487">
                <span className="w-1.5 h-1.5 rounded-full bg-accentwarm mr-2" data-id="element-488"></span>{' '}
                Content gap analysis
              </li>
              <li className="flex items-center text-sm text-customgray" data-id="element-489">
                <span className="w-1.5 h-1.5 rounded-full bg-accentwarm mr-2" data-id="element-490"></span>{' '}
                Technical AEO audits
              </li>
            </ul>
          </div>

          {/* Solution 3 */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-491">
            <div className="w-14 h-14 rounded-xl bg-purple-500/10 flex items-center justify-center mb-6" data-id="element-492">
              <BuildingIcon className="w-7 h-7 text-purple-500" data-id="element-493" />
            </div>
            <h3 className="text-2xl font-bold text-customblack mb-4" data-id="element-494">
              For Agencies
            </h3>
            <p className="text-customgray leading-relaxed flex-grow" data-id="element-495">
              Deliver cutting-edge AEO/GEO services to your clients. Manage
              multiple brands from a single interface, generate white-label
              reports, and provide competitive benchmarking across all major AI
              search engines.
            </p>
            <ul className="mt-6 space-y-3 border-t border-gray-100 pt-6" data-id="element-496">
              <li className="flex items-center text-sm text-customgray" data-id="element-497">
                <span className="w-1.5 h-1.5 rounded-full bg-purple-500 mr-2" data-id="element-498"></span>{' '}
                Multi-tenant architecture
              </li>
              <li className="flex items-center text-sm text-customgray" data-id="element-499">
                <span className="w-1.5 h-1.5 rounded-full bg-purple-500 mr-2" data-id="element-500"></span>{' '}
                White-label reporting
              </li>
              <li className="flex items-center text-sm text-customgray" data-id="element-501">
                <span className="w-1.5 h-1.5 rounded-full bg-purple-500 mr-2" data-id="element-502"></span>{' '}
                Client access portals
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Trusted By Section */}
      <div className="bg-white border-t border-gray-200 py-16" data-id="element-503">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-504">
          <p className="text-sm font-semibold text-customgray uppercase tracking-wider mb-10" data-id="element-505">
            Trusted by forward-thinking teams
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 md:gap-x-16 opacity-40" data-id="element-506">
            {/* Spotify */}
            <svg viewBox="0 0 167 48" className="h-8 w-auto" fill="currentColor" data-id="element-507">
              <path d="M27.5 0C12.3 0 0 12.3 0 27.5S12.3 55 27.5 55 55 42.7 55 27.5 42.7 0 27.5 0zm0 48C16.2 48 7 38.8 7 27.5S16.2 7 27.5 7 48 16.2 48 27.5 38.8 48 27.5 48z" transform="scale(0.87)" data-id="element-508" />
              <path d="M39.2 20.2c-6.5-3.9-17.2-4.2-23.4-2.3-1 .3-2.1-.3-2.4-1.3-.3-1 .3-2.1 1.3-2.4 7.1-2.2 18.9-1.8 26.4 2.7.9.5 1.2 1.7.7 2.6-.6.9-1.7 1.2-2.6.7zm-.4 6.4c-.5.8-1.4 1-2.2.5-5.4-3.3-13.7-4.3-20.1-2.3-.8.2-1.7-.2-2-1-.2-.8.2-1.7 1-2 7.3-2.2 16.4-1.1 22.7 2.7.8.4 1.1 1.4.6 2.1zm-2.5 6.1c-.4.6-1.2.8-1.8.4-4.7-2.9-10.7-3.5-17.7-1.9-.7.2-1.3-.3-1.5-.9-.2-.7.3-1.3.9-1.5 7.6-1.7 14.2-1 19.5 2.2.7.4.9 1.2.6 1.7z" transform="scale(0.87)" data-id="element-509" />
              <text x="52" y="33" fontSize="18" fontWeight="700" fontFamily="system-ui, sans-serif" letterSpacing="-0.5" data-id="element-510">
                Spotify
              </text>
            </svg>

            {/* Slack */}
            <svg viewBox="0 0 130 48" className="h-8 w-auto" fill="currentColor" data-id="element-511">
              <rect x="0" y="14" width="8" height="20" rx="4" data-id="element-512" />
              <rect x="10" y="8" width="8" height="26" rx="4" data-id="element-513" />
              <rect x="0" y="36" width="18" height="8" rx="4" data-id="element-514" />
              <text x="28" y="33" fontSize="18" fontWeight="700" fontFamily="system-ui, sans-serif" letterSpacing="-0.3" data-id="element-515">
                Slack
              </text>
            </svg>

            {/* Notion */}
            <svg viewBox="0 0 140 48" className="h-8 w-auto" fill="currentColor" data-id="element-516">
              <path d="M4 6h12l12 18V6h6v36h-10L12 24v18H4V6z" transform="translate(0, 3) scale(0.85)" data-id="element-517" />
              <text x="38" y="33" fontSize="18" fontWeight="600" fontFamily="system-ui, sans-serif" letterSpacing="-0.3" data-id="element-518">
                Notion
              </text>
            </svg>

            {/* Stripe */}
            <svg viewBox="0 0 120 48" className="h-8 w-auto" fill="currentColor" data-id="element-519">
              <text x="0" y="33" fontSize="22" fontWeight="700" fontFamily="system-ui, sans-serif" letterSpacing="-0.5" data-id="element-520">
                Stripe
              </text>
            </svg>

            {/* Shopify */}
            <svg viewBox="0 0 140 48" className="h-8 w-auto" fill="currentColor" data-id="element-521">
              <path d="M16 8c-.2 0-.4.1-.5.3l-2 6.2-.5-1c-.8-1.7-2.2-2.6-3.8-2.6h-.1L8.5 10c-.5-.6-1.2-.9-2-.9C3.8 9.1 1.2 13 .4 15.5L.1 16.3c-.3.9.1 1.8 1 2.1l1.8.7c.1 3.5 2.2 5.9 5.2 5.9 1.6 0 2.9-.8 3.7-2.2l.5.2c.9.3 1.8-.1 2.1-1l3-9.5c.3-.9-.2-1.8-1-2.1L16 10V8z" transform="translate(0, 7) scale(0.8)" data-id="element-522" />
              <text x="22" y="33" fontSize="18" fontWeight="700" fontFamily="system-ui, sans-serif" letterSpacing="-0.3" data-id="element-523">
                Shopify
              </text>
            </svg>

            {/* Dropbox */}
            <svg viewBox="0 0 150 48" className="h-8 w-auto" fill="currentColor" data-id="element-524">
              <path d="M10 6l8 5-8 5-8-5 8-5zm18 0l8 5-8 5-8-5 8-5zM10 22l8-5 8 5-8 5-8-5zm18 0l8-5v4l-8 5-8-5v-4l8 5z" transform="translate(0, 7) scale(0.75)" data-id="element-525" />
              <text x="32" y="33" fontSize="18" fontWeight="600" fontFamily="system-ui, sans-serif" letterSpacing="-0.3" data-id="element-526">
                Dropbox
              </text>
            </svg>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-primary py-16 text-center px-4" data-id="element-527">
        <h2 className="text-3xl font-bold text-white mb-6" data-id="element-528">
          Start optimizing your brand today
        </h2>
        <Link to="/demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg text-primary bg-white hover:bg-gray-100 transition-colors shadow-lg" data-id="element-529">
          Book a Demo
        </Link>
      </div>
    </main>;
};
export default Solutions;